<template>
  <div class="gs-pager">
    <el-pagination
      background
      :current-page="innerPage"
      :page-size="pageSize"
      :pager-count="5"
      :total="total"
      layout="prev, pager, next"
      @current-change="onPage"
    />
    <div class="gs-pager-jump">
      <input
        v-model="jumpPage"
        type="text"
        inputmode="numeric"
        @keyup.enter="goJump"
      >
      <button type="button" @click="goJump">跳转</button>
    </div>
    <span class="gs-pager-total">共{{ pageCount }}页</span>
  </div>
</template>

<script>
export default {
  name: 'GsPagination',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      jumpPage: String(this.currentPage || 1)
    }
  },
  computed: {
    innerPage() {
      return this.currentPage || 1
    },
    pageCount() {
      const size = this.pageSize || 10
      return Math.max(1, Math.ceil((this.total || 0) / size))
    }
  },
  watch: {
    currentPage(val) {
      this.jumpPage = String(val || 1)
    }
  },
  methods: {
    onPage(page) {
      this.$emit('update:currentPage', page)
      this.$emit('current-change', page)
    },
    goJump() {
      const page = parseInt(String(this.jumpPage).replace(/\D/g, ''), 10)
      const next = Math.min(this.pageCount, Math.max(1, page || 1))
      this.jumpPage = String(next)
      if (next !== this.innerPage) this.onPage(next)
    }
  }
}
</script>

<style scoped>
.gs-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  margin: 20px 0;
}
.gs-pager :deep(.el-pagination) {
  justify-content: center;
  flex-wrap: wrap;
}
.gs-pager-jump {
  display: inline-flex;
  align-items: stretch;
  height: 32px;
  border: 1px solid #0165FF;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}
.gs-pager-jump input {
  width: 52px;
  border: 0;
  outline: none;
  margin: 0;
  padding: 0;
  text-align: center;
  color: #0165FF;
  font-size: 14px;
  background: transparent;
}
.gs-pager-jump button {
  border: 0;
  border-left: 1px solid #0165FF;
  margin: 0;
  padding: 0 14px;
  background: linear-gradient(263deg, #62A0FF 0%, #0165FF 100%);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.gs-pager-total {
  color: #0165FF;
  font-size: 14px;
  line-height: 32px;
  white-space: nowrap;
}
@media (max-width: 960px) {
  .gs-pager {
    gap: 8px;
    margin: 12px 0;
  }
  .gs-pager :deep(.el-pagination) {
    --el-pagination-button-width: 28px;
    --el-pagination-button-height: 28px;
    font-size: 13px;
  }
  .gs-pager-jump {
    height: 28px;
  }
  .gs-pager-jump input {
    width: 40px;
    font-size: 13px;
  }
  .gs-pager-jump button {
    padding: 0 10px;
    font-size: 13px;
  }
  .gs-pager-total {
    font-size: 12px;
    line-height: 28px;
  }
}
</style>
